module.exports = __webpack_public_path__ + "static/media/edit.33ae1541.svg";